import styled from "styled-components";
import Button from "./Button";


export const RedButton = styled(Button)`
    background-color: #EA5757;
`;


// WEBPACK FOOTER //
// ./src/components/Button/RedButton.js